import Destroyer from './classes/destroyer'
import RowSolver from './classes/row_solver'
import ColSolver from './classes/col_solver'
import BoxSolver from './classes/box_solver'
import CreditsPerPuzzleUpgrade from './classes/credits_per_puzzle_upgrade'
import CreditsPerPossibilityUpgrade from './classes/credits_per_possibility_upgrade'
import CreditsPerCellUpgrade from './classes/credits_per_cell_upgrade'
import { SolverNames, UpgradeNames } from './constants'

export function deserializeSolver (data: Record<string, unknown>, puzzle: number[][][], credits: Record<string, number>, noAutos: number[]) {
  let solver
  switch (data.name) {
    case SolverNames.BOX_SOLVER:
      solver = new BoxSolver(puzzle, credits, noAutos)
      break
    case SolverNames.COL_SOLVER:
      solver = new ColSolver(puzzle, credits, noAutos)
      break
    case SolverNames.ROW_SOLVER:
      solver = new RowSolver(puzzle, credits, noAutos)
      break
    default:
      throw new Error('Bad Data failed to parse Solvers')
  }
  solver.nextCost = data.nextCost as number
  solver.solvingSpot = data.solvingSpot as number
  solver.tickTime = data.tickTime as number
  solver.skipCompleted = data.skipCompleted as boolean
  solver.skipCompleteCost = data.skipCompleteCost as number
  solver.recursive = data.recursive as boolean
  solver.recursiveCost = data.recursiveCost as number
  solver.run()
  return solver
}

export function deserializeUpgrade (data: Record<string, string>, credits: Record<string, number>) {
  let upgrade
  switch (data.name) {
    case UpgradeNames.CREDITS_PER_PUZZLE:
      upgrade = new CreditsPerPuzzleUpgrade(credits)
      break
    case UpgradeNames.CREDITS_PER_POSSIBILITY:
      upgrade = new CreditsPerPossibilityUpgrade(credits)
      break
    case UpgradeNames.CREDITS_PER_CELL:
      upgrade = new CreditsPerCellUpgrade(credits)
      break
    default:
      // TODO: Catch load errors and reset game (maybe with warning?)
      throw new Error('Bad Data! No Load for you! (Failed to parse upgrade)')
  }
  upgrade.nextCost = parseInt(data.nextCost, 10)
  return upgrade
}

export function deserializeDestroyer (data: Record<string, number>, puzzle: number[][][], locked: boolean[][]) {
  const destroyer = new Destroyer(puzzle, locked, data.tickTime)
  destroyer.spot = data.spot
  return destroyer
}
